import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import commonEn from "./en/commonEn";
import dashboardEn from "./en/dashboardEn";
import masterEn from "./en/masterEn";
import settingsEn from "./en/settings";
import usersEn from "./en/users";
import maintenanceEn from "./en/maintenanceEn";
import inventoryEn from "./en/inventoryEn";
import docEn from "./en/docEn";
import reportEn from "./en/reportEn";

const resources = {
    en: {
        translation: {
            ...commonEn,
            ...dashboardEn,
            ...masterEn,
            ...settingsEn,
            ...usersEn,
            ...maintenanceEn,
            ...inventoryEn,
            ...docEn,
            ...reportEn,
        }
    },
};

// Initialize i18next
i18n.use(initReactI18next).init({
    resources,
    lng: "en", // Default language
    fallbackLng: "en",
    interpolation: { escapeValue: false }
});

export default i18n;